import React from 'react';
import { FeaturePageLayout } from '../components/FeaturePageLayout';
import { Brain, User, MessageSquare, Globe, Fingerprint, Settings, Database } from 'lucide-react';
/*
  SEO SPECIFICATION:
  Title: Your MISTR — A Personal AI Named After You | MindStream.ing
  Meta Desc: Every client gets their own MISTR, named by their last name. MR Moceri. MR Johnson. MR Blanchard. Your AI COO, built for your business.
  Primary KW: personal AI business assistant
*/
export function YourMistr() {
  return <FeaturePageLayout seoTitle="Your MISTR — A Personal AI Named After You | MindStream.ing" seoDesc="Every client gets their own MISTR, named by their last name. MR Moceri. MR Johnson. MR Blanchard. Your AI COO, built for your business." heroEyebrow="YOUR AI COO" heroTitle={<>
          Meet MISTR. Your AI. <span className="text-gradient" data-id="element-2848">Your Name.</span>
        </>} heroDesc="Every client gets their own MISTR, named by their last name. MR Moceri. MR Johnson. MR Blanchard. Your AI COO, built for your business." heroImage="https://cdn.magicpatterns.com/uploads/dWXrt9xNFh6bNpGwsjysP6/ChatGPT_Image_Mar_20,_2026,_02_15_39_PM.png" howItWorks={{
    title: 'How MR Learns You',
    steps: [{
      title: 'Talk to MR',
      desc: 'Have 3 natural conversations with MR about your business.'
    }, {
      title: 'MR Learns',
      desc: 'MR builds your complete persona profile, values, and history.'
    }, {
      title: 'Perfect Voice',
      desc: 'Every output sounds exactly like you — not a generic AI.'
    }]
  }} features={{
    cards: [{
      icon: <Fingerprint size={24} data-id="element-2849" />,
      title: 'Brand Voice Training',
      desc: 'MR learns your exact tone, vocabulary, and communication style.'
    }, {
      icon: <Settings size={24} data-id="element-2850" />,
      title: 'Client History Ingestion',
      desc: 'Upload past emails and documents so MR understands your context.'
    }, {
      icon: <MessageSquare size={24} data-id="element-2851" />,
      title: 'Tone Matching',
      desc: 'MR learns your exact tone, vocabulary, and communication style.'
    }, {
      icon: <Database size={24} data-id="element-2852" />,
      title: 'Context Ingestion',
      desc: 'Upload past emails and documents so MR understands your context.'
    }, {
      icon: <Globe size={24} data-id="element-2853" />,
      title: 'Multilingual Persona',
      desc: 'Your exact brand voice, translated perfectly into any language.'
    }]
  }} data-id="element-2847" />;
}